export default "__VITE_ASSET__b56mWlh3__"